var _defs, _polygon, _polyline, _polygon2, _polygon3, _polygon4, _polygon5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgShipVan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3a2834;}.cls-2{fill:#594a55;}.cls-3{fill:#33222e;}.cls-4{fill:aqua;}.cls-5{fill:#4c3547;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "203.9 272.02 473.92 254.88 531.07 444.88 175.58 445.35 203.9 272.02"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "206.9 271.02 311.73 231.79 476.92 253.88"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "186.75 467.74 516.78 467.74 531.07 444.88 175.32 444.88 186.75 467.74"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "423.88 486.86 504.47 486.86 517.04 468.2 411.31 468.2 423.88 486.86"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "199.96 486.56 281.56 486.56 294.12 467.91 188.4 467.91 199.96 486.56"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "416.73 445.79 531.32 445.35 474.18 255.34 249.73 219.79 416.73 445.79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgShipVan);
export default __webpack_public_path__ + "static/media/bg-ship-van.c7af264d7823b05fe5ee915f0968a52e.svg";
export { ForwardRef as ReactComponent };